export default __webpack_public_path__ + "static/what-are-we-doing-3-04a13ca9443f8ce1334e75661d8ebab5.png";